module.exports = __webpack_public_path__ + "static/media/Starly_gaussian2.dcaf7a40.png";